// i18n area 'hci' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.sq-AL.meta.json.
import type { enUS } from './hci'

export const sqAL: typeof enUS = {
  hci: {
    ceph: {
      title: 'Klasterët Ceph',
      createButton: 'Krijo klaster Ceph',
      emptyTitle: 'Asnjë klaster Ceph i menaxhuar',
      emptyBody: 'TVirt e shpërndan dhe e zotëron Ceph në nyjet anëtare, hiperkonvergjent me ngarkesën VM. Krijo një klaster: monitori i parë dhe manager-i i tij lindin automatikisht në nyjën e kontrollit të zgjedhur — pastaj rrite me monitorë të tjerë dhe pajisje OSD.',
      pageTitle: 'Klasteri Ceph',
      colState: 'Gjendja',
      colMembers: 'Anëtarët',
      colSize: 'Madhësia',
      colVersion: 'Versioni Ceph',
      sizeCell: '{used} GiB të përdorur nga {total} GiB gjithsej',
      phase: {
        'not-deployed': 'Pa deploy',
        deploying: 'Deploy në proces',
        healthy: 'I shëndetshëm',
        degraded: 'I degraduar',
        error: 'Gabim',
        destroying: 'Në shkatërrim',
        destroyed: 'I shkatërruar'
      },
      health: {
        HEALTH_OK: 'I shëndetshëm (HEALTH_OK)',
        HEALTH_WARN: 'Me paralajmërime (HEALTH_WARN)',
        HEALTH_ERR: 'Në gabim (HEALTH_ERR)',
        unknown: 'Ende e pavëzhguar',
        observedAt: 'vëzhguar {time}'
      },
      create: {
        title: 'Krijo klaster Ceph',
        info: 'Kur krijohet një klaster i ri Ceph duhet zgjedhur nyja e parë ku do të instalohen rolet MON dhe MGR. Duhet specifikuar gjithashtu cili nënrrjet të përdoret për trafikun Ceph: nënrrjeti public përdoret për trafikun e përgjithshëm të rrjetit, ndërsa nënrrjeti cluster përdoret për replikat e brendshme mes OSD-ve; nuk ka nevojë patjetër për nënrrjete të ndryshme.',
        controlNode: 'Nyja e kontrollit',
        controlNodeHint: 'Nyja anëtare ku lindin MON-i i parë + MGR-i.',
        publicSubnet: 'Nënrrjeti public',
        publicSubnetHint: 'Një Subnet e regjistruar në IPAM — public_network-u i Ceph. I pandryshueshëm pas krijimit.',
        clusterSubnet: 'Nënrrjeti cluster',
        clusterSubnetHint: 'Një Subnet e regjistruar në IPAM — cluster_network-u i Ceph (replikë/backfill).',
        noSubnets: 'Asnjë Subnet e regjistruar — krijoji më parë në IPAM',
        sameSubnet: 'I njëjti nënrrjet për trafikun public dhe cluster',
        sameSubnetHint: 'E shënuar = rrjeti cluster (replikë/backfill) përputhet me public-un. E pashënuar = zgjidh nënrrjetin e tij DHE adresën e nyjes së kontrollit brenda tij.',
        controlAddress: 'Adresa e nyjes së kontrollit',
        controlAddressHint: 'Një adresë që IPAM-i e njeh për nyjën brenda nënrrjetit public.',
        controlClusterAddress: 'Adresa cluster e nyjes së kontrollit',
        controlClusterAddressHint: 'Një adresë që IPAM-i e njeh për nyjën brenda nënrrjetit cluster.',
        noAddresses: 'IPAM-i nuk njeh adresa të kësaj nyje brenda nënrrjetit të zgjedhur',
        started: 'Klasteri u krijua — bootstrap-i vazhdon si macrotask; faza përditësohet vetë',
        error: 'Klasteri u refuzua'
      },
      detail: {
        actions: 'Veprime të disponueshme',
        tabOverview: 'Panorama',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pool',
        tabObjects: 'Objektet',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Të avancuara',
        phase: 'Faza',
        checksTitle: 'Check-e shëndeti aktivë',
        noChecks: 'Asnjë check shëndeti aktiv',
        checkMuted: 'i heshtur',
        summaryPools: 'Pool',
        summaryFilesystems: 'Filesystem',
        nodesCard: 'Nyjet',
        monHint: 'Një MGR ekzekutohet i bashkëvendosur me çdo MON. Tre MON janë kuorumi i rekomanduar; një klaster laboratori nis me një. OSD dhe MDS jetojnë në tab-et e tyre.',
        monHintSplit: 'MON dhe MGR janë të shkëputur në këtë klaster (Të avancuara): secili rol është një membership më vete për nyjë. Tre MON janë kuorumi i rekomanduar; të paktën një MGR duhet të ekzistojë.',
        noMons: 'Asnjë monitor i deklaruar',
        addNode: 'Shto nyjë',
        removeNode: 'Hiq nyjën',
        removeNodeFrom: 'Hiq nyjën {node} (MON-in e saj dhe MGR-in e bashkëvendosur)',
        roleMon: 'Roli MON',
        roleMgr: 'Roli MGR',
        roleNa: 'N/A',
        roleNotObserved: 'ende i pavëzhguar',
        monInQuorum: 'në kuorum',
        monOutQuorum: 'jashtë kuorumit',
        mgrActive: 'aktiv',
        mgrStandby: 'standby',
        addRoleMon: 'Shto rolin MON',
        removeRoleMon: 'Hiq rolin MON',
        addRoleMgr: 'Shto rolin MGR',
        removeRoleMgr: 'Hiq rolin MGR',
        restartMon: 'Rinis shërbimin MON',
        restartMgr: 'Rinis shërbimin MGR',
        addMon: 'Shto MON',
        removeMon: 'Hiq MON',
        removeMonFrom: 'Hiq rolin MON nga {node}',
        addMgr: 'Shto MGR',
        removeMgr: 'Hiq MGR',
        removeMgrFrom: 'Hiq rolin MGR nga {node}',
        addMds: 'Shto MDS',
        removeMds: 'Hiq MDS',
        removeMdsFrom: 'Hiq rolin MDS nga {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Asnjë MDS i deklaruar — një filesystem kërkon më parë një',
        mdsHint: 'Membership-i MDS është më vete që nga dita e parë: një klaster pa CephFS nuk deklaron asnjë, një aktiv plus një standby i shërbejnë mirë një filesystem-i. Ceph i zgjedh aktivët dhe standby-t mes daemon-ëve të deklaruar.',
        mdsActiveFor: 'aktiv — {fs}',
        mdsNotObserved: 'ende i pavëzhguar',
        lastMdsGuard: 'MDS-i i fundit nuk mund të hiqet derisa të ekzistojë një filesystem — hiq më parë filesystem-et',
        lastMonGuard: 'MON-i i fundit nuk mund të hiqet — shkatërrimi i klasterit është dalja e vetme',
        lastMgrGuard: 'MGR-i i fundit nuk mund të hiqet — një klaster i menaxhuar nuk ekzekutohet kurrë pa manager',
        registerDevice: 'Shto OSD',
        unregisterDevice: 'Çregjistro',
        activeDeviceGuard: 'OSD aktiv — del përmes ciklit të jetës OSD, jo nga regjistri',
        colNode: 'Nyja',
        devicePhase: { registered: 'I regjistruar', active: 'Aktiv' },
        health: 'Shëndeti',
        state: 'Gjendja',
        fsid: 'fsid',
        fsidPending: 'mungon — riprovo bootstrap-in',
        version: 'Versioni Ceph',
        publicNetwork: 'Rrjeti public',
        clusterNetwork: 'Rrjeti cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Asnjë veprim i disponueshëm në këtë fazë',
        destroyedNote: 'Klaster i shkatërruar — rreshti hiqet automatikisht së shpejti'
      },
      overview: {
        services: 'Shërbimet',
        ok: 'të shëndetshme',
        warning: 'warning',
        down: 'të rëna',
        pgTitle: 'Gjendjet e PG-ve',
        pgTotal: '{n} PG gjithsej',
        capacityTitle: 'Hapësira',
        ioTitle: 'I/O aktual',
        ioReadBw: 'Banda e leximit',
        ioWriteBw: 'Banda e shkrimit',
        ioReadIops: 'IOPS në lexim',
        ioWriteIops: 'IOPS në shkrim',
        notObserved: 'ende i pavëzhguar'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Gjendja',
        colSize: 'Madhësia',
        colPgs: 'PG',
        empty: 'Asnjë OSD — shto një nga një disk të dhënash i deklaruar',
        markIn: 'Shëno IN',
        markOut: 'Shëno OUT',
        scrub: 'Kryej scrub',
        deepScrub: 'Kryej scrub të thellë',
        restart: 'Rinis shërbimin',
        details: 'Detajet',
        actionGuard: 'Vetëm mbi një OSD aktiv të një klasteri të deploy-uar',
        inTitle: 'Shëno OSD IN',
        inBody: 'osd.{id} kthehet në shpërndarjen e të dhënave (ceph osd in): Ceph i ribalancon të dhënat mbi të.',
        outTitle: 'Shëno OSD OUT',
        outBody: 'osd.{id} del nga shpërndarja e të dhënave (ceph osd out): të dhënat e tij ribalancohen gjetkë dhe redundanca është E REDUKTUAR derisa backfill-i të ekzekutohet. E kthyeshme në çdo moment me Shëno IN.',
        scrubTitle: 'Planifiko scrub',
        scrubBody: 'Planifikohet një scrub i osd.{id}: mon-i e fut në radhë dhe gjendjet e PG-ve të sweep-eve pasuese tregojnë përfundimin.',
        deepScrubTitle: 'Planifiko scrub të thellë',
        deepScrubBody: 'Planifikohet një scrub i thellë i osd.{id}: varianti që verifikon byte-t — më i rëndë për I/O-në, e njëjta mekanikë.',
        restartTitle: 'Rinis shërbimin OSD',
        restartBody: 'osd.{id} ndalohet dhe riniset përmes mbikëqyrjes së worker-it në nyjën e tij.',
        started: 'Veprimi u nis — vëzhgimi përditësohet vetë',
        error: 'Veprimi OSD u refuzua'
      },
      osdDetail: {
        title: 'Detajet OSD',
        tabGeneral: 'Të përgjithshme',
        tabNetwork: 'Rrjeti',
        tabDevices: 'Pajisjet',
        version: 'Versioni',
        hostname: 'Hostname',
        dataPath: 'Shtegu i të dhënave OSD',
        objectStore: 'Object store OSD',
        encrypted: 'I enkriptuar',
        yes: 'Po',
        no: 'Jo',
        memory: 'Përdorimi i memories (PSS)',
        pid: 'Process ID (PID)',
        front: 'Adresa front (client & monitor)',
        hbFront: 'Adresa heartbeat front',
        back: 'Adresa back (OSD)',
        hbBack: 'Adresa heartbeat back',
        colDevice: 'Device',
        colType: 'Tipi',
        colPhysical: 'Device fizik',
        colSize: 'Madhësia',
        volumeTitle: 'Detajet e volumit',
        creationTime: 'Data e krijimit',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Asnjë device i vëzhguar për këtë OSD'
      },
      restart: {
        title: 'Rinis shërbimin',
        monBody: 'Daemon-i MON në {node} ndalohet dhe riniset përmes mbikëqyrjes së worker-it.',
        mgrBody: 'Daemon-i MGR në {node} ndalohet dhe riniset përmes mbikëqyrjes së worker-it.',
        started: 'Rinisja u nis — vëzhgimi përditësohet vetë',
        error: 'Rinisja u refuzua'
      },
      encryptionMode: {
        alwaysOn: 'Gjithmonë e aktivizuar (dmcrypt)',
        alwaysOff: 'Gjithmonë e çaktivizuar',
        perOsd: 'Zgjedhje për secilin OSD',
        section: 'Enkriptimi OSD at rest',
        title: 'Ndrysho mënyrën e enkriptimit OSD',
        hint: 'Si përgatiten OSD-të e RINJ. OSD-të ekzistues e mbajnë gjendjen e tyre për-disk: për ta ndryshuar hiqet dhe rikrijohet OSD-ja.',
        body: 'Mënyra bëhet "{mode}" dhe vlen VETËM për OSD-të e RINJ: çdo OSD ekzistues e mban gjendjen e vet aktuale të enkriptimit.',
        apply: 'Ndrysho mënyrën',
        error: 'Ndryshimi i mënyrës u refuzua'
      },
      pin: {
        address: 'Adresa public (pin opsional)',
        clusterAddress: 'Adresa cluster (pin opsional)',
        autoPlaceholder: 'automatike në nënrrjetin {cidr}',
        hint: 'Adresim për-daemon: bosh = Ceph lidhet vetë brenda rrjetit të deklaruar; e plotësuar = kjo instancë pinohet në adresën në seksionin e vet të conf-it.'
      },
      addMon: {
        title: 'Shto nyjë',
        node: 'Nyja',
        address: 'Adresa public',
        addressHint: 'Adresat e nyjes që IPAM-i i njeh brenda nënrrjetit public — automatike kur një deklarim ekzistues e mbulon nyjën.',
        clusterAddress: 'Adresa cluster',
        clusterAddressHint: 'E detyrueshme: nënrrjeti cluster është i ndarë dhe nyja nuk është deklaruar ende aty.',
        noAddresses: 'IPAM-i nuk njeh adresa të kësaj nyje brenda nënrrjetit',
        error: 'Shtimi i mon-it u refuzua'
      },
      removeMon: {
        title: 'Hiq MON',
        body: 'MON-i dhe MGR-i i tij i bashkëvendosur e lënë nyjën {node}. Në një klaster të deploy-uar daemon-ët ndalohen dhe hiqen nga kuorumi.',
        error: 'Heqja e MON-it u refuzua'
      },
      addMgr: {
        title: 'Shto MGR',
        node: 'Nyja',
        hint: 'Të avancuara (MON/MGR të shkëputur): një manager standalone lind në nyjën anëtare të zgjedhur me një task me afinitet ndaj nyjes. Zgjedhja active/standby e Ceph e cakton vetë MGR-in aktiv.',
        error: 'Shtimi i MGR-it u refuzua'
      },
      removeMgr: {
        title: 'Hiq MGR',
        body: 'MGR-i standalone e lë nyjën {node}. Në një klaster të deploy-uar daemon-i ndalohet dhe gjendja e tij hiqet; MON-i i nyjes (nëse ka) nuk preket.',
        error: 'Heqja e MGR-it u refuzua'
      },
      addMds: {
        title: 'Shto MDS',
        node: 'Nyja',
        hint: 'Metadata server-i i CephFS: lind në nyjën anëtare të zgjedhur me një task me afinitet ndaj nyjes, i mbikëqyrur nga worker-i si MON dhe MGR. Ceph i zgjedh vetë aktivët dhe standby-t — një aktiv plus një standby i shërbejnë mirë një filesystem-i.',
        error: 'Shtimi i MDS-it u refuzua'
      },
      removeMds: {
        title: 'Hiq MDS',
        body: 'MDS-i e lë nyjën {node}. Në një klaster të deploy-uar daemon-i ndalohet dhe gjendja e tij hiqet; API-ja e refuzon MDS-in e fundit derisa një filesystem të ketë nevojë për të.',
        error: 'Heqja e MDS-it u refuzua'
      },
      split: {
        title: 'MON/MGR të shkëputur',
        label: 'Lejo MON dhe MGR në nyje të shkëputura',
        hint: 'E fikur (default) = standardi i ratifikuar: një MGR ekzekutohet i bashkëvendosur me çdo MON, një membership i vetëm. E ndezur = membership-i i MGR-ve bëhet më vete, i menaxhuar me veprimet Shto/Hiq MGR në tab-in Nyjet e menaxhimit.',
        enable: 'Aktivizo',
        disable: 'Çaktivizo',
        enableBody: 'Membership-i i MGR-ve bëhet i pavarur nga MON-ët, i inicializuar nga bashkëvendosja aktuale. Veprimet Shto/Hiq MGR armatosen në tab-in Nyjet e menaxhimit. Kjo e relakson default-in e platformës — mbaje vetëm nëse e di pse të duhet.',
        disableBody: 'Kthim te bashkëvendosja standard: një MGR me çdo MON, një membership i vetëm. E ligjshme vetëm nëse membership-i i MGR-ve përputhet tashmë me MON-ët — rreshtoje më parë me Shto/Hiq MGR, ose API-ja do të refuzojë.',
        error: 'Ndryshimi u refuzua'
      },
      rawEditor: {
        title: 'Editori CRUSH i papërpunuar',
        label: 'Shfaq editorin e papërpunuar të crushmap-ës në tab-in CRUSH',
        hint: 'E fikur (default) = sipërfaqja e drejtuar e rregullave është mjeti standard. E ndezur = tab-i CRUSH shfaq edhe crushmap-ën e dekompiluar si tekst të modifikueshëm. Ruajtja kërkon gjithmonë sudo, emrin e klasterit si konfirmim, dhe kalon nga compile + test i crushtool-it PARA se të arrijë klasterin.'
      },
      osdFlags: {
        section: 'Flag OSD globalë',
        title: 'Override i flag-eve OSD',
        notObserved: 'ende të pavëzhguar',
        standardFlowsHint: 'Flukset standard të platformës i menaxhojnë vetë këta flag-e në rastet normale (mirëmbajtja e një nyje vendos një noout të përqendruar, zëvendësimi i diskut kalon nga cikli i jetës OSD). Ky seksion është override-i manual për operatorin që di çfarë po bën.',
        notDeployedGuard: 'Flag-et OSD ekzistojnë vetëm mbi një klaster të deploy-uar',
        set: 'Vendos flag',
        unset: 'Hiq flag',
        setBody: 'Flag-u global {flag} do të VENDOSET në osdmap. Mbetet derisa të hiqet shprehimisht — një flag i harruar e degradon vetë-riparimin e klasterit.',
        unsetBody: 'Flag-u global {flag} do të HIQET nga osdmap-a.',
        error: 'Ndryshimi i flag-ut u refuzua',
        flag: {
          noout: 'Asnjë OSD nuk shënohet out nga shpërndarja e të dhënave — asnjë ribalancim me humbjen e një daemon-i',
          norebalance: 'Ribalancimi i të dhënave është i pezulluar',
          nobackfill: 'Backfill-i është i pezulluar',
          norecover: 'Recovery-ja është e pezulluar',
          pause: 'GJITHË I/O-ja e klientëve është në pauzë (lexime dhe shkrime)',
          noin: 'OSD-të që nisen nuk shënohen in automatikisht',
          nodown: 'OSD-të e paarritshëm nuk shënohen down — maskon defekte reale'
        }
      },
      pools: {
        section: 'Pool',
        create: 'Krijo pool',
        createGuard: 'Pool-et ekzistojnë vetëm mbi një klaster të deploy-uar',
        notObserved: 'Asnjë vëzhgim i pool-eve — sweep-i i mon-it raporton këtu',
        empty: 'Asnjë pool në klaster',
        colName: 'Emri',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplikacioni',
        colRule: 'Rregulli CRUSH',
        colUsage: 'Përdorimi',
        observedAtLabel: 'Vëzhguar më',
        objects: '{n} objekte',
        inUseBy: 'në përdorim nga {name}',
        internalGuard: 'Pool i brendshëm i Ceph — platforma nuk e fshin kurrë',
        delete: 'Fshi pool-in',
        deleteGuard: 'I konsumuar nga storage-i {name} — fshi më parë storage-in',
        hint: 'Vetëm pool-e të replikuar (erasure coding jashtë scope v1). Replika jeton në Ceph: kjo tabelë është e vërteta e vëzhguar nga sweep-i i mon-it.',
        createTitle: 'Krijo pool',
        createHint: 'Pool-i lind në klaster me replikën e kërkuar dhe aplikacionin rbd të aktivizuar — punën e bën një task në një nyjë MON. Ndiz "Propozo si storage" për ta konsumuar menjëherë në të njëjtin gjest.',
        name: 'Emri i pool-it',
        nameHint: 'DNS-safe (shkronja të vogla, shifra, vija ndarëse).',
        size: 'Replika (size)',
        sizeHint: 'Kopje të çdo objekti. Default 3.',
        minSize: 'Replika minimale (min_size)',
        minSizeHint: 'Kopjet minimale për të shërbyer I/O — ndjek size − 1 derisa ta modifikosh.',
        createError: 'Krijimi i pool-it u refuzua',
        deleteTitle: 'Fshi pool-in',
        deleteBody: 'Pool-i {pool} dhe ÇDO objekt brenda tij shkatërrohen në mënyrë të pakthyeshme. Shkruaj emrin e pool-it për të konfirmuar.',
        confirmLabel: 'Emri i pool-it',
        confirmHint: 'Shkruaj emrin e pool-it për të konfirmuar',
        deleteError: 'Fshirja e pool-it u refuzua',
        detailTitle: 'Detajet e pool-it',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktiv',
        autoscalerOff: 'Joaktiv',
        autoscalerWarn: 'Njoftim',
        pgNumLabel: 'Numri i PG-ve',
        pgNumCaption: 'I vëzhguar: autoscaler-i mund ta ndryshojë në autonomi — kjo fushë shkruan një dëshirë.',
        storage: 'Storage TVirt i lidhur',
        addAsStorage: 'Shto si storage TVirt',
        ruleSudoHint: 'Ndryshimi i rregullit CRUSH kërkon fjalëkalimin e operatorit.',
        updateError: 'Ndryshimi i pool-it u refuzua',
        updated: 'Ndryshimi i pool-it u nis — vëzhgimi përditësohet vetë'
      },
      crush: {
        section: 'Rregullat CRUSH',
        notObserved: 'Asnjë vëzhgim CRUSH ende — sweep-i i mon-it raporton këtu',
        empty: 'Asnjë rregull i vëzhguar në klaster',
        hint: 'Një rregull vendos KU përfundojnë kopjet e çdo objekti — domeni i tij i defektit është njësia që mund të prishet pa humbur të dhëna. Pool-et tregojnë drejt një rregulli; replicated_rule builtin (një replikë për server) është default-i i lindjes.',
        create: 'Krijo rregull',
        createGuard: 'Rregullat CRUSH ekzistojnë vetëm mbi një klaster të deploy-uar',
        createTitle: 'Krijo rregull CRUSH',
        createHint: 'Një rregull = një zgjedhje domeni defekti. Rregulli lind i replikuar mbi root-in e default-it — punën e bën një task në një nyjë MON; lidhi pool-et nga tab-i Pool më pas.',
        createError: 'Krijimi i rregullit u refuzua',
        name: 'Emri i rregullit',
        nameHint: 'DNS-safe (shkronja të vogla, shifra, vija ndarëse).',
        domain: 'Domeni i defektit',
        domainChoice: {
          osd: 'Çdo replikë në një OSD tjetër',
          host: 'Çdo replikë në një server tjetër',
          rack: 'Çdo replikë në një rack tjetër'
        },
        domainCustom: 'E personalizuar (step-e të shkruar me dorë)',
        domainOther: 'Çdo replikë në një {type} tjetër',
        rackGuardHint: 'Asnjë bucket rack nuk ekziston në hierarkinë e vëzhguar: rregulli mund të krijohet gjithsesi, por asnjë pool s’do të mund të tregojë drejt tij derisa një rack të deklarohet në pozicionimin e serverëve anëtarë (cilësimet e nyjes) — task-u i ri-rreshtimit e ndërton bucket-in dhe lidhja hapet vetë.',
        treeTitle: 'Hierarkia e vëzhguar',
        treeNotObserved: 'Asnjë vëzhgim i hierarkisë — sweep-i i mon-it raporton këtu',
        treeOsds: '{n} OSD',
        treeHint: 'Harta CRUSH siç e sheh klasteri: root → nivelet e deklaruara → server (host) → OSD. Topologjia ndjek pozicionimin e deklaruar të secilit server (cilësimet e nyjes) — një ndryshim pozicioni e ri-rreshton përmes task-eve.',
        unplacedWarning: 'Anëtarë pa pozicion të deklaruar: {nodes} — host-et e tyre mbeten drejtpërdrejt nën root, jashtë topologjisë së deklaruar. Deklaro pozicionin te cilësimet e nyjes (një paralajmërim, kurrë një bllokim).',
        colName: 'Emri',
        colDomain: 'Domeni i defektit',
        colPools: 'Pool',
        builtinChip: 'builtin',
        builtinGuard: 'Rregulli i default-it i klasterit — platforma nuk e fshin kurrë',
        detailAction: 'Detajet e rregullit',
        detailType: 'Tipi',
        backToRules: 'Rregullat',
        ruleNotObserved: 'Lista e vëzhguar e rregullave nuk e përmend këtë rregull',
        noPools: 'Asnjë pool nuk e përdor këtë rregull',
        delete: 'Fshi rregullin',
        deleteTitle: 'Fshi rregullin CRUSH',
        deleteBody: 'Rregulli {rule} hiqet nga crushmap-a e klasterit. Asnjë pool nuk duhet ta përdorë. Shkruaj emrin e rregullit për të konfirmuar.',
        deleteGuard: 'I përdorur nga pool-i {name} — ridrejtoje më parë pool-in',
        confirmLabel: 'Emri i rregullit',
        confirmHint: 'Shkruaj emrin e rregullit për të konfirmuar',
        deleteError: 'Fshirja e rregullit u refuzua',
        changeRule: 'Ndrysho rregullin CRUSH',
        changeRuleTitle: 'Ndrysho rregullin CRUSH',
        changeRuleHint: 'Pool-i fillon t’i vendosë objektet e vet sipas rregullit të zgjedhur — Ceph i lëviz të dhënat ekzistuese për t’u konformuar (mbi një pool plot pason një ribalancim).',
        changeRuleError: 'Ndryshimi i rregullit u refuzua',
        rule: 'Rregulli CRUSH',
        rawTitle: 'Crushmap e papërpunuar (e dekompiluar)',
        rawWarning: 'RREZIK: ky tekst është E GJITHË politika e pozicionimit e klasterit. Një hartë e gabuar mund ta prishë placement-in e të gjithë pool-eve bashkë. Ruajtja e kompilon dhe e kolaudon hartën me crushtool PARA se ta injektojë — por një hartë e vlefshme mund të jetë gjithsesi një ide e keqe.',
        rawReload: 'Ringarko',
        rawLoading: 'Query në fluturim — një task read-only po e dekompilon crushmap-ën…',
        rawSave: 'Ruaj crushmap-ën',
        rawSaveTitle: 'Injekto crushmap-ën',
        rawSaveBody: 'Teksti i modifikuar e zëvendëson crushmap-ën e GJITHË klasterit pas compile + test të crushtool-it. Shkruaj emrin e klasterit për të konfirmuar.',
        rawConfirmLabel: 'Emri i klasterit',
        rawConfirmHint: 'Shkruaj {name} për të konfirmuar',
        rawError: 'Operacioni mbi crushmap-ën dështoi',
        rawHint: 'Teksti është forma crushtool -d. Gabimet e kompilimit dhe të testit kthehen fjalë për fjalë nga crushtool — harta nuk e arrin klasterin nëse njëri nga dy portat dështon.'
      },
      objects: {
        poolsSection: 'Eksploruesi i objekteve',
        poolsHint: 'Zgjidh një pool për të listuar imazhet e tij RBD. Çdo lexim i thellë ekzekutohet si task read-only në një nyjë MON — nuk bllokon (dhe as bllokohet nga) operacionet reale.',
        deployedGuard: 'Query-t mbi objektet përgjigjen vetëm mbi një klaster të deploy-uar',
        browse: 'Shfleto objektet',
        detailAction: 'Detajet e imazhit',
        backToPools: 'Pool',
        backToImages: 'Imazhet',
        refresh: 'Rifresko',
        loading: 'Query në fluturim — një task read-only po e interrogon klasterin…',
        error: 'Query-ja dështoi',
        retry: 'Riprovo',
        notRbd: 'Pool me application "{app}" — nuk përmban imazhe RBD, asgjë për të eksploruar këtu',
        noImages: 'Asnjë imazh RBD në këtë pool',
        colImage: 'Imazhi',
        colSize: 'Madhësia',
        colObjects: 'Objektet',
        colSnapshots: 'Snapshot',
        imagesHint: 'Disqet mbi një storage rbd konsumues janë imazhe me emrin e id-së së tyre të diskut. Numërimi i objekteve është provisioned-i (madhësia / madhësia e objektit) — përdorimi real jeton te detajet e imazhit.',
        infoTitle: 'Imazhi',
        infoSize: 'Madhësia virtuale',
        infoObjects: 'Objekte (provisioned)',
        infoObjectSize: 'Madhësia e objektit',
        infoPrefix: 'Prefiksi i objekteve',
        infoFormat: 'Formati',
        infoFeatures: 'Feature',
        usageTitle: 'Përdorimi real (rbd du)',
        usageOf: 'nga {provisioned} GiB provisioned',
        usageHint: 'Thin nga natyra: vetëm objektet e shkruar zënë byte.',
        watchersTitle: 'Watcher',
        noWatchers: 'Asnjë watcher — askush nuk e ka këtë imazh të hapur tani',
        snapshotsTitle: 'Snapshot RBD',
        noSnapshots: 'Asnjë snapshot RBD mbi këtë imazh',
        colSnapshot: 'Snapshot',
        colProtected: 'I mbrojtur',
        colTimestamp: 'Krijuar',
        protected: 'i mbrojtur',
        mappingTitle: 'Harta fizike (bashkësia e OSD-ve)',
        mappingSampled: 'Kampion prej {sampled} objektesh nga {total} — përmbledhje e ndershme: për imazhe të mëdha bashkësia konvergon te TË GJITHË OSD-të e pool-it (CRUSH i shpërndan objektet mbi gjithë pool-in).',
        mappingComplete: 'Të gjithë objektet të hartuar ({total} nga {total}).',
        objectQueryTitle: 'Harto një objekt të vetëm',
        objectName: 'Emri i objektit',
        objectHint: 'Emrat e objekteve RADOS janë <prefiks>.<indeks 16-hex> — ceph osd map përgjigjet me PG dhe treshet OSD.',
        mapObject: 'Harto',
        primary: 'primari: osd.{osd}'
      },
      registerDevice: {
        title: 'Regjistro pajisje OSD',
        hint: 'Mbi një klaster të gjallë regjistrimi e PËRGATIT edhe pajisjen: bëhet një OSD BlueStore me një task automatik me afinitet ndaj nyjes (kurrë bosh, ratifikuar 2026-07-24). Një pajisje i përket të shumtën një klasteri Ceph në gjithë flotën.',
        disk: 'Disk të dhënash',
        diskHint: 'Disqet e të dhënave të deklaruar të nyjes — emri dhe seriali',
        noDeclared: 'Asnjë disk të dhënash i deklaruar në këtë nyjë — shënoji më parë te cilësimet lokale të nyjes',
        serialHint: 'Seriali i pajisjes — pin-i i identitetit',
        encrypted: 'Enkripto këtë OSD (dmcrypt)',
        encryptedHint: 'Zgjedhja për-OSD (mënyra e klasterit është "zgjedhje për secilin OSD"): ngrin mbi këtë disk në regjistrim — një ndryshim i mëvonshëm i mënyrës nuk e rishkruan kurrë; e bën veprimi i rreshtit enkripto/dekripto.',
        error: 'Regjistrimi u refuzua'
      },
      unregisterDevice: {
        title: 'Çregjistro pajisjen',
        body: 'Vetëm në regjistër: {name} pushon së qeni kandidat OSD i këtij klasteri. Byte-t e tij nuk preken.',
        error: 'Çregjistrimi u refuzua'
      },
      deploy: {
        action: 'Riprovo deploy-in',
        title: 'Riprovo bootstrap-in',
        body: 'Bootstrap-i i lindjes rifillon nga konfigurimi aktual: mon-ët nisen, çdo pajisje e regjistruar përgatitet dhe aktivizohet si OSD BlueStore. Operacioni ekzekutohet si macrotask — faza përditësohet vetë.',
        started: 'Bootstrap-i u nis — vazhdon si macrotask; faza përditësohet vetë',
        error: 'Bootstrap-i u refuzua'
      },
      propose: {
        action: 'Propozo si storage',
        title: 'Propozo si storage',
        hintPool: 'Pool-i ekzistues {name} bëhet një storage TVirt: një identitet cephx i kufizuar te pool-i përfundon në keystore dhe storage-i ceph-rbd lind gati. Propozimi e konsumon pool-in — nuk krijon kurrë një të ri.',
        hintFs: 'Filesystem-i ekzistues {name} bëhet një storage TVirt: një identitet cephx i kufizuar te filesystem-i përfundon në keystore dhe storage-i cephfs lind gati dhe i montuar. Propozimi e konsumon filesystem-in — nuk krijon kurrë një të ri.',
        name: 'Emri i storage-it',
        nameHint: 'DNS-1123, unik në scope — identiteti cephx e merr emrin prej tij.',
        path: 'Shtegu brenda filesystem-it',
        pathHint: 'Shteg absolut brenda filesystem-it që storage-i monton — / në mëdyshje.',
        alsoPropose: 'Propozoje menjëherë si storage',
        alsoProposePoolHint: 'Pas krijimit i njëjti gjest e propozon pool-in e sapolindur si storage ceph-rbd — dy thirrje eksplicite, një dialog i vetëm.',
        alsoProposeFsHint: 'Pas krijimit i njëjti gjest e propozon filesystem-in e sapolindur si storage cephfs — dy thirrje eksplicite, një dialog i vetëm.',
        guard: 'Propozo si storage — vetëm mbi një klaster healthy',
        started: 'Propozimi u pranua — storage-i po materializohet; e gjen nën Storage',
        submit: 'Krijo storage',
        error: 'Propozimi u refuzua'
      },
      fs: {
        section: 'Filesystem',
        create: 'Krijo filesystem',
        createGuard: 'Filesystem-et ekzistojnë vetëm mbi një klaster të deploy-uar',
        mdsFirstGuard: 'Shto më parë një MDS — një filesystem pa metadata server lind i papërdorshëm',
        notObserved: 'Asnjë vëzhgim i filesystem-eve — sweep-i i MON-it raporton këtu',
        empty: 'Asnjë filesystem në klaster',
        colName: 'Emri',
        colPools: 'Pool',
        colMds: 'MDS',
        noActiveMds: 'asnjë MDS aktiv',
        delete: 'Hiq filesystem-in',
        deleteGuard: 'I konsumuar nga storage-i {name} — fshi më parë storage-in',
        hint: 'Një filesystem i zotëron pool-et e veta të dhënash dhe metadata (cephfs.<emri>.data / .meta): lindin me të dhe vdesin me të — removeFs, kurrë një delete pool-i me dorë. Kjo tabelë është e vërteta e vëzhguar nga sweep-i i MON-it.',
        createTitle: 'Krijo filesystem',
        createHint: 'Filesystem-i lind në klaster me dy pool-et e vet (application cephfs) dhe shërbehet nga MDS-të e deklaruar — punën e bën një task në një nyjë MON. Ndiz "Propozo si storage" për ta konsumuar menjëherë në të njëjtin gjest.',
        name: 'Emri i filesystem-it',
        nameHint: 'DNS-safe (shkronja të vogla, shifra, vija ndarëse).',
        sizeHint: 'Replika të TË DY pool-eve që lindin. Default 3.',
        createError: 'Krijimi i filesystem-it u refuzua',
        deleteTitle: 'Hiq filesystem-in',
        deleteBody: 'Filesystem-i {fs} dhe ÇDO skedar brenda tij shkatërrohen në mënyrë të pakthyeshme — pool-et e tij të dhënash dhe metadata vdesin me të. Shkruaj emrin e filesystem-it për të konfirmuar.',
        confirmLabel: 'Emri i filesystem-it',
        confirmHint: 'Shkruaj emrin e filesystem-it për të konfirmuar',
        deleteError: 'Heqja e filesystem-it u refuzua'
      },
      destroy: {
        action: 'Shkatërro',
        retryAction: 'Riprovo fshirjen',
        retryGuard: 'Shkatërrimi është duke u ekzekutuar — retry vlen për një shkatërrim të dështuar (lease-i refuzon përndryshe)',
        title: 'Shkatërro klasterin',
        body: 'Fabric-u i deploy-uar çmontohet: çdo daemon i këtij klasteri ndalet, gjendja e tij e sistemit dhe çelësat në keystore lirohen. Me shkatërrimin e kryer klasteri hiqet automatikisht.',
        confirmLabel: 'Emri i klasterit',
        confirmHint: 'Shkruaj emrin e klasterit për të konfirmuar',
        wipe: 'Pastro pajisjet e regjistruara',
        wipeHint: 'E shënuar: firmat e çdo pajisjeje të regjistruar pastrohen — të dhënat sipër janë të shkatërruara. E pashënuar: byte-t mbeten të paprekur dhe pajisjet kthehen të regjistruara.',
        guard: 'Shkatërro — asgjë e deploy-uar',
        started: 'Shkatërrimi u nis — vazhdon si macrotask; faza përditësohet vetë',
        error: 'Shkatërrimi u refuzua'
      },
      delete: {
        guard: 'Fshi — vetëm një konfigurim pa deploy (më parë shkatërro)',
        title: 'Të fshihet {name}?',
        body: 'Konfigurimi dhe regjistri i tij i pajisjeve hiqen. E ligjshme vetëm derisa asgjë s’është e deploy-uar.',
        error: 'Fshirja u refuzua'
      }
    }
  }
}
